import { useEffect, useState } from "react";
import PaymentForm from "../components/PaymentForm";
import Header from "../components/layout/Header";
import CarritoCompras from "../components/CarritoCompras";
import { useProductos } from "../hooks/useProductos";
import { useParams } from "react-router-dom";

const Confirmation = () => {
    const [openCart, setOpenCart] = useState(false);

    const { orden, cart, getOrden, formatoCOP } = useProductos();
    const { norden } = useParams();

    useEffect(() => {
        if (norden) {
            getOrden(norden);
        }
    }, []);


    return (
        <>
            <div className="wrapper" style={{ maxWidth: "100%", background: "#000000" }}>
                <Header setOpenCart={setOpenCart} openCart={openCart} />
                <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
                <div className="wrapper" style={{ margin: "100px auto", background: "#000000" }}>
                    <div className="container-preview" style={{ flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%" }}>
                        <h1>Total a pagar {formatoCOP.format(orden?.total)}</h1>
                        <PaymentForm />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Confirmation;